import QUERY_ORGANIZATIONS_BY_NAME from '../../organizations/queries/OrganizationsByNameQuery.gql';
import ORGANIZATION_PICKER_INITIAL from '../../organizations/queries/OrganizationPickerInitialQuery.gql';
import RemindAPI from 'lib/RemindAPI';
import {
  QueryOrganizationsByName,
  QueryOrganizationsByNameVariables,
} from 'organizations/queries/__generated__/QueryOrganizationsByName';
import {
  OrganizationPickerInitial,
  OrganizationPickerInitialVariables,
} from 'organizations/queries/__generated__/OrganizationPickerInitial';

// @ts-ignore
import { Organization } from '../types';

type SuccessResponse<T> = { success: true } & T;
type ErrorResponse<E> = { success: false } & E;
export type ActionResponse<T, E = { errorMessage: string }> = SuccessResponse<T> | ErrorResponse<E>;

export async function findOrganizationsByName(
  name: string
): Promise<ActionResponse<{ organizations: Organization[] }>> {
  try {
    const { organizationsByName: resp } = await RemindAPI.execute<
      QueryOrganizationsByName,
      QueryOrganizationsByNameVariables
    >({
      query: QUERY_ORGANIZATIONS_BY_NAME,
      variables: {
        input: {
          name,
        },
      },
    });

    return { success: true, organizations: resp.results as Organization[] };
  } catch (e) {
    return { success: false, errorMessage: 'find organization by name request failed' };
  }
}

export async function organizationPickerInitial(
  uuid: string
): Promise<ActionResponse<{ organization: Organization }>> {
  try {
    const { organizations } = await RemindAPI.execute<
      OrganizationPickerInitial,
      OrganizationPickerInitialVariables
    >({
      query: ORGANIZATION_PICKER_INITIAL,
      variables: {
        uuid,
      },
    });

    if (organizations[0]) {
      return { success: true, organization: organizations[0] as Organization };
    } else {
      return { success: false, errorMessage: 'no organization found' };
    }
  } catch (e) {
    return { success: false, errorMessage: 'find initial organization request failed' };
  }
}
